export const en = {
  app: {
    name: '3DGS Explorer',
  },
  common: {
    newVersionDetected: 'A new version is available. Please refresh to get the latest content.',
    refreshNow: 'Refresh now',
  },
  explore: {
    scaffoldHint: 'Current sceneId =',
  },
  errors: {
    notFound: 'Page not found',
    'missing-scene-id': 'Missing scene-id parameter',
    'scene-offline': 'This scene is offline',
    'preview-token-invalid': 'Preview token is invalid or expired',
    back: 'Back',
    'access-denied': 'Access Denied',
    'access-denied-desc':
      'You do not have permission to view this scene. Please contact the creator for an invitation.',
    'access-denied-login': 'Log in',
    'back-to-platform': 'Back to Platform',
    'scene-not-found': 'Scene Not Found',
    'scene-not-found-desc': 'The scene you are looking for does not exist or has been removed.',
  },
  scene: {
    by: 'By',
    noDescription: 'No description provided.',
  },
  share: {
    'link-copied': 'Link copied',
    'copy-failed': 'Copy failed',
    'copy-permission-denied': 'Clipboard permission was denied. Please copy the link manually.',
    share: 'Share',
    'close-share': 'Close share',
  },
  toolbar: {
    vrMode: 'XR',
    sceneInfo: 'Scene info',
    goBack: 'Go back',
    flyMode: 'Fly mode',
    walkMode: 'Walk mode',
    orbitMode: 'Orbit mode',
    screenshot: 'Screenshot',
    measureTool: 'Measure',
    exitMeasure: 'Exit measure',
    playCinematic: 'Play cinematic',
    pauseCinematic: 'Pause cinematic',
    hotspots: 'Open hotspots',
    closeHotspots: 'Close hotspots',
    close: 'Close',
    cancel: 'Cancel',
    vrWebglTitle: 'Switch to WebGL mode',
    vrWebglDesc:
      'VR requires WebGL rendering. The page will reload. After it finishes loading, click the VR button again to enter.',
    vrWebglConfirm: 'Switch to WebGL',
    vrQualityTitle: 'Select VR Quality',
    vrQualityLowest: 'Lowest',
    vrQualityLow: 'Low',
    vrQualityMedium: 'Medium',
    vrQualityHigh: 'High',
    vrQualityHigher: 'Higher',
    vrQualityHighest: 'Ultra',
    firstPerson: 'First person',
    thirdPerson: 'Third person',
    characterRoam: 'Character roam',
    flyDesc: 'Q/E to ascend/descend',
    walkDesc: 'Tab to switch view',
    orbitDesc: 'Drag to rotate view',
    cinema: '3D Race Track',
    assetLibrary: 'Asset Library',
  },
  raceTrack: {
    pause: 'Pause (Space)',
    play: 'Play (Space)',
    needKeyframes: 'Need at least 2 keyframes to play ({{count}}/2)',
    hidePreview: 'Hide preview',
    showPreview: 'Show preview',
    lookMode: 'Look mode',
    lookAuto: 'Auto',
    lookForward: 'Forward',
    lookCenter: 'Center',
    interpolation: 'Interpolation',
    interpolationStep: 'Step',
    interpolationSpline: 'Spline',
    smooth: 'Smooth',
    addKeyframe: 'Add keyframe at current camera (F)',
    updateKeyframe: 'Update keyframe to current camera (U)',
    deleteSelected: 'Delete selected keyframe (Delete/Backspace)',
    deleteAll: 'Delete all keyframes',
    jumpToStart: 'Jump to beginning (G)',
    jumpToPrevious: 'Jump to previous keyframe (H)',
    jumpToNext: 'Jump to next keyframe (L)',
    jumpToEnd: 'Jump to end (;)',
    undoOptimize: 'Undo optimize',
    optimizeTrack: 'Optimize track',
    exportVideo: 'Export video',
    closeEditor: 'Close editor',
    timelineTrack: 'Timeline track',
    keyframeAt: 'Keyframe at {{time}}s',
    playhead: 'Playhead',
    preview: 'Preview',
    aspectRatio: 'Aspect ratio',
    closePreview: 'Close preview',
    loadingPreview: 'LOADING PREVIEW',
    resizeHandle: 'Resize handle',
    previewFailed: 'Preview failed',
    exportTitle: 'Export Video',
    resolution: 'Resolution',
    resolutionSquare: 'Square 1080p (1080×1080)',
    resolution1080p: 'Full HD 1080p (1920×1080)',
    resolution720p: 'HD 720p (1280×720)',
    resolutionOriginal: 'Original viewport',
    frameRate: 'Frame rate',
    fps24: '24 fps (Film)',
    fps30: '30 fps (Standard)',
    fps60: '60 fps (Smooth)',
    codec: 'Codec',
    codecH264: 'H.264 / AVC',
    codecVp9: 'VP9',
    codecVp8: 'VP8',
    quality: 'Quality',
    qualityStandard: 'Standard',
    qualityHigh: 'High',
    qualityUltra: 'Ultra',
    exporting: 'Exporting…',
    exportProgress: 'Export progress',
    exportFailed: 'Export failed',
    cancel: 'Cancel',
    sceneNotReady: 'Scene is not ready for export',
    needTwoKeyframes: 'At least two keyframes are required to export video',
    sceneTimeout: 'Scene load timed out, unable to start export',
    mediaRecorderUnsupported: 'MediaRecorder is not supported in this browser',
    exportCanvasFailed: 'Export recording canvas was not created',
  },
  assetLibrary: {
    title: 'Asset Library',
    close: 'Close',
    translate: 'Translate',
    rotate: 'Rotate',
    scale: 'Scale',
    dropHint: 'Drag GLB/GLTF file or folder, or click to select',
    urlPlaceholder: 'Or enter URL...',
    import: 'Import',
    selectModel: 'Select a model to edit transform',
    position: 'Position',
    rotation: 'Rotation (rad)',
    scaleLabel: 'Scale',
    noModels: 'No models imported yet',
    duplicate: 'Duplicate model',
    rename: 'Rename',
    delete: 'Delete model',
    gltfNotSupported:
      '.gltf format requires external resource files. Please convert to .glb before importing.',
    importFailed: 'Model import failed. Please check the file format.',
    unsupportedFormat: 'Only .glb and .gltf files are supported',
    folderSelect: 'Select folder',
  },
  hotspots: {
    title: 'Hotspots',
    sceneNavigation: 'Scene navigation',
    close: 'Close hotspots',
    empty: 'No hotspots in this scene.',
    flyTo: 'Fly to this point of interest.',
    previous: 'Previous hotspot',
    next: 'Next hotspot',
    openHotspot: 'Open hotspot {{title}}',
    hotspot: 'Hotspot',
    closeHotspot: 'Close hotspot',
    noDescription: 'No description provided.',
  },
  user: {
    feedback: 'Send feedback',
    feedbackTitle: 'Send Feedback',
    feedbackPlaceholder: 'Describe your feedback…',
    feedbackSubmit: 'Submit (API pending)',
    points: 'Points',
    pointsLoading: 'Loading…',
    pointsAvailable: 'Credits',
    pointsTotalGranted: 'Total granted',
    pointsTotalConsumed: 'Consumed',
    pointsFailed: 'Not logged in or failed to load',
    userInfo: 'User Info',
    login: 'Log in',
    logout: 'Log out',
    notLoggedIn: 'Not logged in',
    user: 'User',
  },
};
